import React from "react";
import { useHistory } from "react-router-dom";
import { C } from "./ipd-billing/constants";
import SvgIcon from "./ipd-billing/SvgIcon";
import SchemeServiceNamesScreen from "./ipd-billing/components/SchemeServiceNames";

// ─────────────────────────────────────────────────────────────────────────────
// Scheme Service Names admin (manager landing tile → /scheme-service-names)
//
// Sibling of Corporate Rate Cards under the "Rate cards" hub. Maps a hospital
// service to the name/code a health scheme (WBHS, CGHS, …) prints on its invoices.
// Rendered inside IPDBillingAppShell (app navbar + background + permissions).
// ─────────────────────────────────────────────────────────────────────────────
export default function SchemeServiceNames() {
  const history = useHistory();

  return (
    <div style={{ minHeight: "calc(100vh - 140px)", background: C.bg }}>
      <style>{`
        @keyframes ipdFadeIn { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: none; } }
        .crc-btn { transition: background 0.12s, box-shadow 0.12s; }
      `}</style>

      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          padding: "18px 32px",
          background: C.card,
          borderBottom: `1px solid ${C.border}`,
        }}
      >
        <button
          onClick={() => history.push("/main-landing")}
          className="crc-btn"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "7px 12px",
            background: "#fff",
            border: `1px solid ${C.border}`,
            borderRadius: "8px",
            color: C.text,
            fontSize: "13px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          <SvgIcon name="back" size={16} color={C.text} />
          Home
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "9px",
              background: C.primary,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SvgIcon name="invoice" size={18} color="#fff" />
          </div>
          <div>
            <div style={{ fontSize: "17px", fontWeight: 800, color: C.text }}>
              Scheme Service Names
            </div>
            <div style={{ fontSize: "11px", color: C.textSub, fontWeight: 600 }}>
              Scheme invoice service-name aliases · tenant-wide setup
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: "24px 32px" }}>
        <SchemeServiceNamesScreen />
      </div>
    </div>
  );
}
